import {ChangeEvent, FC} from 'react';
import clsx from 'clsx';
import {t} from 'i18next';

type DropdownSelectSearchProps = {
    className?: string;
    onSearchOption: (userInput: string) => void;
    searchQuery?: string;
};

const DropdownSelectSearch: FC<DropdownSelectSearchProps> = ({
    className,
    onSearchOption,
    searchQuery,
}) => (
    <input
        aria-label="Search Input"
        className={clsx(
            'pointer-events-auto mb-1 h-10 w-full rounded border border-grey-600 px-3 outline-none placeholder-shown:truncate',
            'focus-visible:border-blue-400 focus-visible:ring-1 focus-visible:ring-blue-200',
            className,
        )}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
            onSearchOption(event.target.value);
        }}
        placeholder={t('search')}
        value={searchQuery}
    />
);

DropdownSelectSearch.displayName = 'DropdownSelectSearch';

export default DropdownSelectSearch;
